import { YesNoButtonProps } from '../interface/interface';

export const YesNoButton = ({
  yesOnClick,
  noOnClick,
  yesLabel,
  noLabel,
  yesClassName,
  noClassName,
}: YesNoButtonProps) => {
  return (
    <>
      <button
        className={`${yesClassName} mr-4 bg-primary-blue-500 text-white px-4 py-2 rounded`}
        onClick={yesOnClick}
      >
        {yesLabel}
      </button>
      <button
        className={`${noClassName} bg-white border border-solid border-primary-blue-500 text-primary-blue-500 px-4 py-2 rounded`}
        onClick={noOnClick}
      >
        {noLabel}
      </button>
    </>
  );
};
